import { css } from '@emotion/react'

const styles = {
  container: css`
        min-height: calc(100vh - 60px);
    `,
}

export default styles
